module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-05-c8c47c0d7d0dd9ca3a450cebad4388e1.svg";